module.exports = __webpack_public_path__ + "img/Bodice-Back-Ja-Kb-Lc.bc3d800a.png";